// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let AllImages = require("./AllImages.bs.js");
let ImageGrid = require("./ImageGrid.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let MarkupHelpers = require("../../../reason/common/MarkupHelpers/MarkupHelpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let TMPUIKIT____ImgGallery = require("../../../temporaryUIKit/TMPUIKIT____ImgGallery/TMPUIKIT____ImgGallery.bs.js");
let ImageGallery_image_graphql = require("../../../__generated__/ImageGallery_image_graphql.bs.js");

let convertFragment = ImageGallery_image_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ImageGallery_image_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ImageGallery_image_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ImageGallery_image_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ImageGallery_image_graphql.node, convertFragment, fRef);
}

let ImageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ImageGallery$MobileViewAllButton(props) {
  return JsxRuntime.jsx("button", {
    children: JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(IconV5.make, {
          icon: "picture",
          size: 16
        }),
        JsxRuntime.jsx("div", {
          children: "View all photos"
        })
      ],
      className: "flex flex-row items-center gap-2"
    }),
    className: "bg-tan-blue-500 absolute cursor-pointer text-white rounded px-4 py-1.5 font-medium bottom-[-12px] right-[4px]",
    onClick: props.onPress
  });
}

let MobileViewAllButton = {
  make: ImageGallery$MobileViewAllButton
};

function ImageGallery(props) {
  let images = RescriptRelay_Fragment.useFragment(ImageGallery_image_graphql.node, convertFragment, props.images);
  let match = React.useState(() => false);
  let setIsAllImagesOpen = match[1];
  let isAllImagesOpen = match[0];
  let match$1 = React.useState(() => {});
  let setSelectedImage = match$1[1];
  let selectedImage = match$1[0];
  let match$2 = React.useState(() => false);
  let setIsFullscreenCarouselOpen = match$2[1];
  let isFullscreenCarouselOpen = match$2[0];
  let match$3 = React.useState(() => false);
  let setIsFullscreenCarouselVisible = match$3[1];
  let isMobile = MediaQuery.isMobile();
  let onSelectImage = i => {
    setSelectedImage(param => i);
    setIsFullscreenCarouselOpen(param => true);
  };
  let onAllImagesClose = React.useCallback(() => setIsAllImagesOpen(param => false), [setIsAllImagesOpen]);
  let imagesForCarousel = images.map(image => ({
    fullscreen: image.carouselFullscreen,
    large: image.carouselLarge,
    small: image.carouselSmall,
    thumb: image.carouselThumb
  }));
  if (images.length === 0) {
    return null;
  }
  let match$4 = isFullscreenCarouselOpen || isAllImagesOpen;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(AllImages.make, {
        isOpen: isAllImagesOpen,
        onClose: onAllImagesClose,
        images: images.map(image => image.fragmentRefs),
        onSelectImage: onSelectImage,
        isFullscreenCarouselVisible: match$3[0],
        isFullscreenCarouselOpen: isFullscreenCarouselOpen,
        selectedImage: selectedImage
      }),
      JsxRuntime.jsx(TMPUIKIT____ImgGallery.CarouselDialog.make, {
        isOpen: isFullscreenCarouselOpen,
        onDismiss: () => setIsFullscreenCarouselOpen(param => false),
        children: JsxRuntime.jsx(TMPUIKIT____ImgGallery.Carousel.make, {
          images: imagesForCarousel,
          onSelect: i => setSelectedImage(param => i),
          selectedIndex: Stdlib_Option.getOr(selectedImage, 0),
          imgSize: "fullscreen"
        }),
        transitionOnDestroyed: () => setIsFullscreenCarouselVisible(param => isFullscreenCarouselOpen)
      }),
      isMobile ? (
          match$4 ? JsxRuntime.jsx(TMPUIKIT____ImgGallery.ResponsiveImage.make, {
              image: imagesForCarousel[Stdlib_Option.getOr(selectedImage, 0)],
              alt: "",
              imgSize: "small"
            }) : JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(TMPUIKIT____ImgGallery.LightCarousel.make, {
                  images: imagesForCarousel,
                  openModal: () => setIsFullscreenCarouselOpen(param => true),
                  onSelect: i => setSelectedImage(param => i),
                  selectedIndex: Stdlib_Option.getOr(selectedImage, 0)
                }),
                JsxRuntime.jsx(ImageGallery$MobileViewAllButton, {
                  onPress: param => setIsAllImagesOpen(param => true)
                })
              ],
              className: "relative"
            })
        ) : JsxRuntime.jsx(MarkupHelpers.Container.make, {
          children: JsxRuntime.jsx(ImageGrid.make, {
            images: images.map(image => image.fragmentRefs),
            onViewAll: param => setIsAllImagesOpen(param => true),
            onSelectImage: onSelectImage
          })
        })
    ]
  });
}

let Gallery;

let CarouselImg;

let make = ImageGallery;

exports.ImageFragment = ImageFragment;
exports.Gallery = Gallery;
exports.CarouselImg = CarouselImg;
exports.MobileViewAllButton = MobileViewAllButton;
exports.make = make;
/* react Not a pure module */
